import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 36, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.05, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHead = ({ overline, title, description, testId, align = "left" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={testId}>
    <FadeUp>
      <p className="text-[11px] sm:text-xs uppercase tracking-overline text-gold mb-5">{overline}</p>
    </FadeUp>
    <FadeUp delay={0.08}>
      <h2 className="font-display text-4xl sm:text-5xl leading-[1.06] tracking-tight text-cream">{title}</h2>
    </FadeUp>
    {description && (
      <FadeUp delay={0.16}>
        <p className="mt-5 text-base md:text-lg text-zinc-400 font-light leading-relaxed">{description}</p>
      </FadeUp>
    )}
    <FadeUp delay={0.22}>
      <div className={`gold-rule w-24 mt-7 ${align === "center" ? "mx-auto" : ""}`} />
    </FadeUp>
  </div>
);
